<template>
  <div class="body">
    <div class="container">
      <img :src="this.image" :class="selectImg()" />
      <div class="details">
        <div class="title" :style="titleStyle">{{ title }}</div>
        <div class="noteDetails">
          <div class="note" v-if="rating > 0" @click="goNote">
            <span v-for="n in 5" :key="n">
              <img
                v-if="rating >= n"
                class="star"
                alt="full star"
                src="../../assets/rate_full.png"
              />
              <img v-else class="star" alt="full star" src="../../assets/rate_empty.png" />
            </span>
          </div>
          <div v-else class="noteText" @click="goNote">{{ $t('tasting.rate') }}</div>
          <div class="taste" @click="$emit('click')">{{ $t('tasting.taste') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import unrated from '@/assets/rate_empty.png'
import rated from '@/assets/rate_full.png'
import degusted from '@/assets/wine_full.png'
import undegusted from '@/assets/wine_empty.png'

export default {
  name: 'VvMobileTasteTilee',
  props: {
    title: {
      type: String,
      required: true
    },
    ratingPath: {
      type: String,
      required: true
    },
    fontSize: {
      type: Number,
      required: true
    },
    image: {
      type: String,
      required: false
    },
    status: {
      type: Object,
      required: false
    },
    bottleId: {
      type: String,
      required: false
    },
    mini: {
      type: Boolean,
      default: false
    },
    rating: {
      type: Number,
      required: false
    }
  },
  computed: {
    iconRate() {
      if (this.status && 'rating' in this.status) return rated
      else if (!this.status) return unrated
      else return unrated
    },
    iconWine() {
      if (this.status && this.status['complete']) return degusted
      else if (!this.status) return undegusted
      else return undegusted
    },
    isBtnShow() {
      return process.env.VUE_APP_APP_NAME == 'vinovibes'
    },
    product() {
      return this.$store.state.bottle.byId[this.bottleId]
    },
    isDesktop() {
      return ['mobile', 'tablet'].includes(this.$mq) ? false : true
    },
    titleStyle() {
      return {
        fontSize: `${this.fontSize}px`
      }
    }
  },
  methods: {
    go() {
      if (this.$route.path.includes('/theme/')) {
        localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
      }
      this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
    },
    goNote() {
      if (this.$route.path.includes('/theme/')) {
        localStorage.setItem('comingFromTasteThemeId', this.$route.params.themeId)
      }
      this.$router.push({ name: 'tasting-rating', params: { tastingId: this.ratingPath } })
    },
    selectImg() {
      return this.mini ? 'imgMini' : 'img'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.noteText {
  color: #ffff;
  background-color: #404040;
  border-radius: 30px;
  width: 55%;
  padding: 5px 12px;
  cursor: pointer;
  text-align: center;
  font-weight: 700;
  font-size: 13px;
}
.star {
  display: block;
  margin: auto;
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.taste {
  display: flex;
  color: #ffff;
  background-color: #404040;
  border-radius: 30px;
  margin-top: 5px;
  justify-content: center;
  padding: 5px;
  width: 100px;
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
}
.noteDetails {
  display: flex;
  flex-direction: column;
  margin-bottom: -20px;
  padding-right: 50px;
}
.note {
  background-color: #404040;
  border-radius: 30px;
  width: 75%;
  display: flex;
  flex-direction: row;
  padding: 6px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
}
.title {
  font: normal normal bold 22px Helvetica; //16pt
  letter-spacing: 0.66px;
  color: #000000;
  width: 100%;
  overflow-wrap: break-word;
}
.details {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  width: 50%;
}
.img {
  object-fit: cover;
  height: 140px;
  margin-left: -20px;
}
.imgMini {
  object-fit: cover;
  height: 150px;
  width: 120px;
  margin-left: -20px;
}
.container {
  display: flex;
  flex-direction: row;
}
.body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
</style>
